export default __webpack_public_path__ + "static/media/printing-block4.ad7b88de.png";